/**
 * Piropa: device firma "El Piropo del Día" (home hero, compartible).
 * Reusa el mismo patrón de parseo del banco que piropa-cart-toast.js (JSON
 * array o líneas de settings.pi_banco_piropos, con fallback), pero acá el
 * piropo mostrado en el primer paint es estable por fecha (día del año %
 * length) — no random — para que "el piropo del día" sea el mismo durante
 * el día. El botón "Dame otro" sí rota al azar.
 */
(function () {
  /**
   * Lista de emergencia. 2026-08-03: hasta hoy tenía 5 piropos y era la que se
   * estaba usando DE VERDAD en el live — settings.pi_banco_piropos no estaba
   * materializado en settings_data.json, Liquid emitía `null` y getPiropos()
   * caía acá. Síntoma reportado: "con 5 clicks dio la vuelta".
   * Se arregló el origen (el banco ahora existe en settings_data), pero esta
   * lista se amplía igual: si algún día vuelve a fallar, que no se note tanto.
   */
  var FALLBACK_PIROPOS = [
    'Hoy andas para comerte el mundo.',
    'Esa sonrisa debería estar prohibida.',
    'Tienes ese brillo que ni el dorado te alcanza.',
    'Con esas manos hasta un piropo se queda corto.',
    'Andas regia y lo sabes, reina.',
    'Naciste para que te miren dos veces.',
    'El detalle que faltaba eras tú.',
    'Hoy no pasas piola: brillas.',
    'Nada te queda tan bien como la seguridad.',
    'Que se note que te elegiste.',
    'Tienes manos de portada.',
    'Brilla sin pedir permiso.',
    'Lo tuyo no es suerte, es estilo.',
    'Te ves preciosa, y ni siquiera lo intentaste.',
    'Eres tu propio piropo favorito.',
  ];

  function getPiropos() {
    var dataEl = document.getElementById('piropa-pdd-banco-data');
    if (!dataEl) return FALLBACK_PIROPOS;

    var raw;
    try {
      raw = JSON.parse(dataEl.textContent);
    } catch (e) {
      return FALLBACK_PIROPOS;
    }
    if (typeof raw !== 'string') return FALLBACK_PIROPOS;

    var list = null;
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) list = parsed;
    } catch (e) {
      list = null;
    }
    if (!list) list = raw.split(/\r?\n/);

    list = list
      .map(function (piropo) {
        return String(piropo || '').trim();
      })
      .filter(Boolean);

    return list.length ? list : FALLBACK_PIROPOS;
  }

  function dayOfYear() {
    var now = new Date();
    var start = new Date(now.getFullYear(), 0, 0);
    var diff = now - start;
    return Math.floor(diff / 86400000);
  }

  function initCard(card) {
    var piropos = getPiropos();
    var textEl = card.querySelector('[data-piropa-pdd-text]');
    var nextBtn = card.querySelector('[data-piropa-pdd-next]');
    var shareBtn = card.querySelector('[data-piropa-pdd-share]');
    var feedbackEl = card.querySelector('[data-piropa-pdd-feedback]');
    var feedbackTimeout;
    var currentIndex = dayOfYear() % piropos.length;

    function render() {
      if (textEl) textEl.textContent = piropos[currentIndex];
    }

    /**
     * Bolsa barajada en vez de random puro: se recorren TODOS los piropos antes
     * de repetir uno. Con random puro (lo que había) el mismo piropo podía salir
     * a los pocos clics aunque el banco fuera grande, y se leía como "ya dio la
     * vuelta". Al agotarse la bolsa se rebaraja evitando que el primero de la
     * nueva tanda sea el que quedó en pantalla.
     */
    var bolsa = [];

    function rellenarBolsa() {
      bolsa = [];
      for (var i = 0; i < piropos.length; i++) {
        if (i !== currentIndex) bolsa.push(i);
      }
      for (var k = bolsa.length - 1; k > 0; k--) {
        var j = Math.floor(Math.random() * (k + 1));
        var tmp = bolsa[k];
        bolsa[k] = bolsa[j];
        bolsa[j] = tmp;
      }
    }

    function rotate() {
      if (piropos.length < 2) {
        render();
        return;
      }
      if (!bolsa.length) rellenarBolsa();
      currentIndex = bolsa.pop();
      render();
    }

    function showFeedback(message) {
      if (!feedbackEl) return;
      feedbackEl.textContent = message;
      clearTimeout(feedbackTimeout);
      feedbackTimeout = setTimeout(function () {
        feedbackEl.textContent = '';
      }, 2500);
    }

    function share() {
      var text = piropos[currentIndex] + ' — Piropa · #UnPiropoParaTi';
      var url = window.location.href;

      if (navigator.share) {
        navigator.share({ text: text, url: url }).catch(function () {});
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text + ' ' + url)
          .then(function () {
            showFeedback('¡Copiado! Listo para compartir 💌');
          })
          .catch(function () {});
        return;
      }

      showFeedback(text);
    }

    render();
    if (nextBtn) nextBtn.addEventListener('click', rotate);
    if (shareBtn) shareBtn.addEventListener('click', share);
  }

  document.querySelectorAll('[data-piropa-pdd]').forEach(initCard);
})();
